<template>
  <div class="layout-wrapper" :class="{ collapsed: !sidebarOpened }">
    <sidebar class="sidebar-container" />
    <div class="main-container">
      <navbar />
      <div class="content-scroll">
        <app-main />
      </div>
    </div>
  </div>
</template>

<script>
import Sidebar from './components/Sidebar'
import Navbar from './components/Navbar'
import AppMain from './components/AppMain'

export default {
  components: {
    Sidebar,
    Navbar,
    AppMain
  },
  created() {
    this.$store.dispatch('system/fetchConfig').catch(() => {})
  },
  computed: {
    sidebarOpened() {
      return this.$store.state.app.sidebarOpened
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@/styles/variables.scss";

.layout-wrapper {
  min-height: 100vh;
}

.sidebar-container {
  width: $sideBarWidth;
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  z-index: 1001;
  overflow-y: auto;
  transition: width 0.25s ease;
}

.main-container {
  margin-left: $sideBarWidth;
  min-width: 0;
  background: #f5f7fa;
  height: 100vh;
  display: flex;
  flex-direction: column;
  transition: margin-left 0.25s ease;
}

.content-scroll {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
}

.layout-wrapper.collapsed {
  .sidebar-container {
    width: $hideSideBarWidth;
  }

  .main-container {
    margin-left: $hideSideBarWidth;
  }
}
</style>
